const NotificationConfigStyles = ({ theme }: any) => ({
  switches: {
    minWidth: theme.spacing(1) * 16,
    flexShrink: 0,
  },
})

export default NotificationConfigStyles
